import React, { useState } from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { motion, AnimatePresence } from 'framer-motion';
import { Users, FileText, PaintRoller, ArrowLeft } from 'lucide-react';

// IMPORT YOUR COMPONENTS HERE (Adjust paths based on your folder structure)
import { Userreg } from '../user/userreg';
import { CusSub } from '../admin/cusSub';
import DataEntryComponent from '../admin/marquee'; // or wherever marquee is located

export const Offices = () => {
  // State to manage which view is currently open ('cards', 'users', 'submissions', 'marquee')
  const [activeView, setActiveView] = useState('cards');

  // Array to map through for generating the cards cleanly
  const officeCards = [
    { 
      id: 'users', 
      title: 'User Management', 
      icon: Users, 
      desc: 'View, add, and manage user accounts and roles.', 
      variant: 'primary',
      bgClass: 'bg-primary-subtle text-primary' 
    },
    { 
      id: 'submissions', 
      title: 'Submissions', 
      icon: FileText, 
      desc: 'Review and process customer data submissions.', 
      variant: 'success',
      bgClass: 'bg-success-subtle text-success'
    },
    { 
      id: 'marquee', 
      title: 'Marquee Settings', 
      icon: PaintRoller, 
      desc: 'Update scrolling announcements and text alerts.', 
      variant: 'warning',
      bgClass: 'bg-warning-subtle text-warning'
    }
  ];

  return (
    <div className="office-container p-2">
      <AnimatePresence mode="wait">
        
        {/* VIEW 1: THE 3 CARDS */}
        {activeView === 'cards' ? (
          <motion.div
            key="cards-view"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
          >
            <h4 className="mb-4 text-muted fw-bold">Office Administration</h4>
            <Row className="g-4">
              {officeCards.map((card) => (
                <Col md={4} key={card.id}>
                  <Card className="h-100 shadow-sm border-0 rounded-4 custom-hover-card">
                    <Card.Body className="p-4 d-flex flex-column align-items-center text-center">
                      
                      {/* Icon Circle */}
                      <div 
                        className={`rounded-circle d-flex align-items-center justify-content-center mb-3 ${card.bgClass}`} 
                        style={{ width: '70px', height: '70px' }}
                      >
                        <card.icon size={32} />
                      </div>
                      
                      <Card.Title className="fw-bold mb-2">{card.title}</Card.Title>
                      <Card.Text className="text-muted small mb-4 flex-grow-1">
                        {card.desc}
                      </Card.Text>
                      
                      <Button 
                        variant={`outline-${card.variant}`} 
                        className="w-100 rounded-pill fw-medium"
                        onClick={() => setActiveView(card.id)}
                      >
                        Open {card.title}
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </motion.div>
        ) : (
          
          /* VIEW 2: THE TABLES/COMPONENTS */
          <motion.div
            key="component-view"
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.2 }}
          >
            {/* Back Button Header */}
            <div className="d-flex align-items-center mb-4 pb-2 border-bottom">
              <Button 
                variant="light" 
                className="d-flex align-items-center gap-2 me-3 shadow-sm"
                onClick={() => setActiveView('cards')}
              >
                <ArrowLeft size={18} /> Back to Office
              </Button>
              <h5 className="mb-0 text-capitalize fw-bold text-muted">
                {activeView} Management
              </h5>
            </div>

            {/* Render the specific component based on state */}
            <div className="component-wrapper">
              {activeView === 'users' && <Userreg />}
              {activeView === 'submissions' && <CusSub />}
              {activeView === 'marquee' && <DataEntryComponent />}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};